<!-- Section Généralités -->
<app-collapse
  [title]="'P00032.status.generalite' | translate"
  [warning]="
    actionStack!.getValue('snSEtatPile') === 1 || hasProductWarning() !== 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00032.status.alimentation' | translate"
      [value]="
        actionStack!.getValue('snSSourceAlimentation') === 0
          ? ('P00032.status.pile' | translate)
          : ('P00032.status.secteur' | translate)
      "
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00032.status.etatPile' | translate"
      [warning]="actionStack!.getValue('snSEtatPile') !== 0"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00032.status.ok' | translate"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00032.status.tensionPile' | translate"
        [value]="mVToVolt(actionStack!.getValue('snSTensionPile') * 100) ?? ''"
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P00032.status.coProduit' | translate"
      [warning]="hasProductWarning() === 2"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00032.status.ok' | translate"
    />
  </div>
</app-collapse>

<!-- Section Redox -->
<app-collapse [title]="'P00032.status.redox' | translate">
  <div slot="contenu">
    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00032.status.tensionRX' | translate"
        [value]="
          actionStack!.getValue('snSentreeSondeRx') +
          ('P00032.status.mV' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00032.status.offsetCalib' | translate"
        [value]="
          actionStack!.getValue('snSConstanteSondeRx') +
          ('P00032.status.mV' | translate)
        "
      />
    }

    <app-display-rubrique-status
      [title]="'P00032.status.dateEtalonnage' | translate"
      [value]="actionStack!.getValue('snSEtalonageRx')"
    />
  </div>
</app-collapse>

<!-- Section pH -->
<app-collapse [title]="'P00032.status.ph' | translate">
  <div slot="contenu">
    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00032.status.tensionBrute' | translate"
        [value]="
          actionStack!.getValue('snSEntreeSondePh') +
          ('P00032.status.mV' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00032.status.offsetCalib' | translate"
        [value]="
          (actionStack!.getValue('snSConstanteSondePh') / 100).toFixed(2) +
          ' ' +
          ('P00032.status.ph' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00032.status.gainCalib' | translate"
        [value]="
          convertTauxAccroissement(
            actionStack!.getValue('snSTauxAccroissement')
          )
        "
      />
    }

    <app-display-rubrique-status
      [title]="'P00032.status.dateEtalonnage' | translate"
      [value]="actionStack!.getValue('snSEtalonnagePh')"
    />
  </div>
</app-collapse>

<!-- Section Température (support technique seulement) -->
@if (isSupportTechnique()) {
  <app-collapse [title]="'P00032.status.Teau' | translate">
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="'P00032.status.dureeT.' + getTemperatureType() | translate"
        [value]="
          convertSecondsToTime(
            actionStack!.getValue('snSNombreSecondeTemperatureEleve')
          )
        "
      />
    </div>
  </app-collapse>
}

<!-- Section Débit -->
<app-collapse [title]="'P00032.status.debit' | translate">
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00032.status.detectionDebit' | translate"
      [value]="
        actionStack!.getValue('snSPresenceDebit') === 0
          ? ('P00032.status.non' | translate)
          : ('P00032.status.oui' | translate)
      "
    />
  </div>
</app-collapse>
